import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  modalAction,
  companyAction,
} from './../../actions/'
import {
  authSelector,
  modalSelector,
  companySelector,
} from './../../selectors'
import { searchCompanys } from '../../function'
import CustomModal from '../../components/modal'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditCompany from './edit'
import ListCompany from './list'
import CompanyForm from '../../components/company'
import CustomModalMessage from '../../components/modal-message'

class CompanyPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      span: false,
      company_code: '',
      company: '',
      id: '',
      start_date: '',
      search: '',
      defaultCompanys: [],
      companys: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    this.props.getAuth(localStorage.getItem('access_token'))
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'listCompanyData') && this.state.search === '') {
      this.setState({
        companys: get(nextProps, 'listCompanyData'),
        defaultCompanys: get(nextProps, 'listCompanyData'),
      })
    }
    if (get(nextProps, 'companyCreate.companyCreate')) {
      this.props.showModal(
        'company',
        get(nextProps, 'companyCreate.status'),
        get(nextProps, 'companyCreate.message')
      )
      this.props.listCompany(localStorage.getItem('access_token'))
      this.props.resetCreateCompany()
    }
    if (get(nextProps, 'companyEdit.companyEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'company',
        get(nextProps, 'companyEdit.status'),
        get(nextProps, 'companyEdit.message')
      )
      if (get(nextProps, 'companyEdit.status') === 200) this.showSave()
      this.props.listCompany(localStorage.getItem('access_token'))
      this.props.resetEditCompany()
      this.handleClickEdit(false, '')
    }
    if (get(nextProps, 'companyDeactivate.companyDeactivate')) {
      this.props.showConfirm(
        'deleteCompany',
        get(nextProps, 'companyDeactivate.status'),
        get(nextProps, 'companyDeactivate.message')
      )
      this.props.listCompany(localStorage.getItem('access_token'))
      this.props.resetDeactivateCompany()
    }
    if (get(nextProps, 'exportURL')) {
      window.open(get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportCompany()
    }
  }
  handleClickSearch() {
    this.setState({ companys: get(this.state, 'defaultCompanys').filter(searchCompanys, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ companys: get(this.state, 'defaultCompanys'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editCompany, company_id) {
    this.setState({
      edit: editCompany,
      id: company_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your company information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('companyForm')
  }
  cancelForm() {
    this.props.hideModal('companyForm')
  }
  cancelAlert() {
    this.props.hideModal('company')
  }
  submitForm() {
    this.props.createCompany(
      {
        company_code: this.state.company_code,
        name: this.state.company,
        start_date: new moment(this.state.start_date),
      },
      localStorage.getItem('access_token'))
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectCompany.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectCompany.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetching')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportCompany(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          get(this.props, 'modalType') === 'company' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ get(this.props, 'modalType') === 'company' }
              type={ get(this.props, 'modalStatus') }
              message={ get(this.props, 'modalMessage') }
            />
        }
        {
          get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'confirmSave' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          get(this.props, 'confirmType') === 'deleteCompany' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'deleteCompany' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <Row noGutters>
          <Col>
            <ListCompany
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              companys={ this.state.companys }
              table={ 1 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditCompany
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ get(this.props, 'confrimType') }
                confirmStatus={ get(this.props, 'confirmStatus') }
                confirmType={ get(this.props, 'confirmType') }
                confirmMessage={ get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ get(this.props, 'modalType') === 'companyForm' } toggle={ this.cancelForm }>
          <CompanyForm
            create={ true }
            button={ button }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            company_code={ this.company_code }
            start_date={ this.state.start_date }
            company={ this.state.company }
            confirm={ get(this.props, 'modalType') }
            cancelForm={ this.cancelForm }
            modalStatus={ get(this.props, 'modalStatus') }
            modalType={ get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

CompanyPage.propTypes = {
  createCompany: PropTypes.func.isRequired,
  resetCreateCompany: PropTypes.func.isRequired,
  listCompany: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  resetEditCompany: PropTypes.func.isRequired,
  resetDeactivateCompany: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  getIsFetching: companySelector.getIsFetching,
  redirectAuth: authSelector.redirectAuth,
  redirectCompany: companySelector.redirectCompany,
  companyCreate: companySelector.getCreateCompanyData,
  companyEdit: companySelector.getEditCompanyData,
  companyDeactivate: companySelector.getDeactivateCompanyData,
  listCompanyData: companySelector.getListCompany,
  exportURL: companySelector.getExportURL,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  createCompany: companyAction.createCompany,
  resetCreateCompany: companyAction.resetCreateCompany,
  resetEditCompany: companyAction.resetEditCompany,
  resetDeactivateCompany: companyAction.resetDeactivateCompany,
  listCompany: companyAction.getCompany,
  exportCompany: companyAction.exportCompany,
  resetExportCompany: companyAction.resetExportUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(CompanyPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/company/index.js